import { Button, Card, Stack, Typography } from '@locus-taxy/encore-mui';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';
import { getTestId } from '@locus-taxy/encore-utils';
import { TestIdAction } from '../../utils/testIdUtils';

interface SessionAccessSectionProps {
  onLogout: () => void;
}

export function SessionAccessSection({
  onLogout,
}: Readonly<SessionAccessSectionProps>) {
  const { t } = useTranslation();

  return (
    <Card
      elevation={0}
      variant="outlined"
      data-testid={getTestId({ action: TestIdAction.VIEW, object: 'session-access-section', page: 'account' })}
    >
      <Stack direction="row" alignItems="center" spacing={2} padding="24px 32px">
        <Typography variant="h6" fontWeight={600} color="text.primary" flex={1}>
          {t('userDetails.sessionAccess', 'Session & Access')}
        </Typography>

        <Button
          variant="outlined"
          size="large"
          color="error"
          onClick={onLogout}
          data-testid={getTestId({ action: TestIdAction.LOGOUT, object: 'button', page: 'account' })}
        >
          {t('userDetails.logout', 'Logout')}
        </Button>
      </Stack>
    </Card>
  );
}
